import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ControlAcceso",
  "use": "ControlAcceso-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ControlAcceso\"><path d=\"M32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0zm0 3C15.984 3 3 15.984 3 32s12.984 29 29 29 29-12.984 29-29S48.016 3 32 3zm0 50a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-34a2 2 0 0 1 2 2v11.515l13.861 8.003a2 2 0 1 1-2 3.464l-14.722-8.5a2 2 0 0 1-1-1.748A2.002 2.002 0 0 1 30 33V21a2 2 0 0 1 2-2zM9 31a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm46 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM32 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol